import React, { useEffect, useState } from 'react'
import {
  Grid,
  useTheme,
  CircularProgress,
  Badge,
  useMediaQuery
} from '@mui/material'
import { TextBold } from '../../../../commonComponents/TextStyling'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import serverData from '../../../../api/ServerData'
import { logoutUser } from '../../../../actions/loginActions'
import CandidateItem from './CandidateItem'
import NoRecordFound from '../../../../commonComponents/NoRecordFound'

export default function TrackCandidate () {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const theme = useTheme()

  const matches = useMediaQuery(theme.breakpoints.down('sm')) // Detect small screens
  const [candidateData, setCandidateData] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(function () {
    getTrackCandidates()
  }, [])

  function getTrackCandidates () {
    serverData.getTrackCandidates(
      {},
      result => {
        if (result.status) {
          setCandidateData(result.response)
        }
        setLoading(false)
      },
      error => {
        setLoading(false)
        if (error.status === 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <TextBold style={{ fontSize: matches ? '18px' : '24px' }}>
          Candidates submitted by you
        </TextBold>
        <Badge
          badgeContent={candidateData?.length}
          color='primary'
          style={{ left: 14, top: -8 }}
        />
      </Grid>
      {loading ? (
        <Grid
          container
          spacing={2}
          direction={'column'}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '70vh',
            width: '100%'
          }}
        >
          <Grid item>
            <CircularProgress />
          </Grid>
        </Grid>
      ) : candidateData.length > 0 ? (
        candidateData?.map(item => (
          <CandidateItem
            item={item}
            onReload={getTrackCandidates}
            matches={matches}
          />
        ))
      ) : (
        <NoRecordFound />
      )}
    </Grid>
  )
}
